export enum ExpenseAllocationMode {
  Planned = 'Planned',
  Committed = 'Committed',
  Closed = 'Closed'
}
